import { LazyLoadUtils, ThemeUtils } from "../../utils/index.js";

export const loadSILinksComponent = (isMobile, brandId, clientProvider) => {
  const dynamicPart = `${brandId}/${clientProvider}/`;

  return LazyLoadUtils.lazyWithFallback(
    () =>
      import(
        /* webpackChunkName: "[request]" */
        `../Brands/${dynamicPart}SILinks.${isMobile ? "mobile" : "pc"}.layout.js`
      ),
    { componentName: "loadSILinksComponent" }
  );
};

export const preload = ({ isMobile, clientProvider, brandId }) => {
  if (!ThemeUtils.isSITheme()) {
    return;
  }

  const Component = loadSILinksComponent(isMobile, brandId, clientProvider);

  Component?.preload();
};
